module.exports = __webpack_public_path__ + "static/deban-24cc3806dc3b8e309ebe0652765448cf.m4a";